import { render, staticRenderFns } from "./ProductDetailsPrice.vue?vue&type=template&id=e5dc428c&scoped=true"
import script from "./ProductDetailsPrice.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc428c",
  null
  
)

export default component.exports